import { useMemo } from "react";
import { useAppSelector } from "@store";

export const stackedProjectRegExp = /stk|stack|stacked/i;

export const useIsStackedProject = () => {
  const { currentProject } = useAppSelector((state) => state.project);
  const isStackedProject = useMemo(() => {
    if (!currentProject || !currentProject.originProjectId) return false;
    return stackedProjectRegExp.test(currentProject.originProjectId);
  }, [currentProject]);

  return {
    isStackedProject,
  };
};
